import styled from 'styled-components';
import { Grid as SemanticGrid } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Grid = styled(SemanticGrid)`
  height: 100%;
  &&& {
    margin: 0;
    padding: 0;
  }
`;

export const Column = styled(SemanticGrid.Column)`
  &&&& {
    padding: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-wrap: anywhere;
  }
`;

export const RightPanel = styled.div`
  background-color: transparent;
  width: 100%;
  padding: 18px 30px 0 30px;
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const RightBarContainer = styled.div`
  overflow: auto;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 25px;
  flex-direction: column;
`;

export const Title = styled(TextLayoutComponent)`
  font-size: 16px;
  color: ${(props) => props.theme.color.textSecondary};
`;

export const QuestionOrder = styled(TextLayoutComponent.Bold)`
  font-size: 16px;
  color: ${(props) => props.theme.color.textSecondary};
  white-space: nowrap;
  margin-right: 5px;
`;
